// extracted by mini-css-extract-plugin
module.exports = {"arrowRight":"ArrowRight_arrowRight__3k7bK"};